"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBackgroundColorFromStyle = exports.getTotalItemsInCart = exports.getDefaultOptionsForMenuItem = exports.getDefaultOption = exports.trimMemuItemForCart = void 0;
const trimMemuItemForCart = (menuItem) => {
    return {
        drinkId: menuItem.drinkId,
        name: menuItem.name,
        price: menuItem.price,
        soldOut: menuItem.soldOut,
        alcoholServings: menuItem.alcoholServings,
    };
};
exports.trimMemuItemForCart = trimMemuItemForCart;
const getDefaultOption = (optionGroup) => {
    if (optionGroup.options.length) {
        return optionGroup.options[0];
    }
};
exports.getDefaultOption = getDefaultOption;
const getDefaultOptionsForMenuItem = (menuItem) => {
    const defaultOptions = [];
    menuItem.optionGroups.forEach((optionGroup) => {
        const opt = (0, exports.getDefaultOption)(optionGroup);
        if (optionGroup.required && opt) {
            defaultOptions.push(opt);
        }
    });
    return defaultOptions;
};
exports.getDefaultOptionsForMenuItem = getDefaultOptionsForMenuItem;
const getTotalItemsInCart = (cart) => cart.reduce((accum, row) => {
    return accum + row.quantity;
}, 0);
exports.getTotalItemsInCart = getTotalItemsInCart;
const DEFAULT_MENU_TILE_COLORS = [
    {
        backgroundColor: '#147eb3',
    },
    {
        backgroundColor: '#3560b4',
    },
    {
        backgroundColor: '#284680',
    },
    {
        backgroundColor: '#49b6e4',
    },
    {
        backgroundColor: '#05668d',
    },
    {
        backgroundColor: '#49516f',
    },
    {
        backgroundColor: '#6279b8',
    },
];
const getElementForExtendedIndex = (list, index) => {
    return list[index % list.length];
};
const getBackgroundColorFromStyle = ({ index, menuTileColors, }) => {
    const tileColors = menuTileColors && menuTileColors.length > 0 ? menuTileColors : DEFAULT_MENU_TILE_COLORS;
    return getElementForExtendedIndex(tileColors, index).backgroundColor;
};
exports.getBackgroundColorFromStyle = getBackgroundColorFromStyle;
//# sourceMappingURL=drinks.js.map